var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container py-4" }, [
    _c("div", { staticClass: "hero" }, [
      _c(
        "div",
        { staticClass: "hero-content" },
        [
          _vm._m(0),
          _c("ScheduleDemo", { attrs: { signedIn: _vm.isSignedIn } }),
        ],
        1
      ),
    ]),
    !_vm.isSignedIn
      ? _c(
          "div",
          {
            staticClass: "alert alert-primary text-center mt-4 mb-3",
            staticStyle: {
              "background-color": "#e6e0ff",
              color: "#4f47c7",
              "font-weight": "500",
            },
            attrs: { role: "alert" },
          },
          [
            _c("strong", [_vm._v("VibeTap is currently free!")]),
            _vm._v(
              " Join as an early venue partner to help shape the future of VibeTap and unlock future discounts. "
            ),
          ]
        )
      : _vm._e(),
    !_vm.isSignedIn
      ? _c("h2", { staticClass: "text-center" }, [
          _vm._v("What Can VibeTap Do for Your Venue?"),
        ])
      : _vm._e(),
    !_vm.isSignedIn
      ? _c(
          "div",
          { staticClass: "features" },
          _vm._l(_vm.businessFeatures, function (feature, index) {
            return _c("div", { key: index, staticClass: "feature-card" }, [
              _c("div", {
                staticClass: "icon ms-4",
                domProps: { innerHTML: _vm._s(feature.icon) },
              }),
              _c("div", { staticClass: "text-content" }, [
                _c("h3", { staticClass: "feature-title" }, [
                  _vm._v(_vm._s(feature.title)),
                ]),
                _c("p", { staticClass: "feature-description" }, [
                  _vm._v(_vm._s(feature.description)),
                ]),
              ]),
            ])
          }),
          0
        )
      : _vm._e(),
    !_vm.isSignedIn
      ? _c("h2", { staticClass: "text-center my-2" }, [
          _vm._v("What Can VibeTap Do for Your Customers?"),
        ])
      : _vm._e(),
    !_vm.isSignedIn
      ? _c(
          "div",
          { staticClass: "features" },
          _vm._l(_vm.features, function (feature, index) {
            return _c("div", { key: index, staticClass: "feature-card" }, [
              _c("div", {
                staticClass: "icon ms-4",
                domProps: { innerHTML: _vm._s(feature.icon) },
              }),
              _c("div", { staticClass: "text-content" }, [
                _c("h3", { staticClass: "feature-title" }, [
                  _vm._v(_vm._s(feature.title)),
                ]),
                _c("p", { staticClass: "feature-description" }, [
                  _vm._v(_vm._s(feature.description)),
                ]),
              ]),
            ])
          }),
          0
        )
      : _vm._e(),
    !_vm.isSignedIn
      ? _c(
          "div",
          {
            staticClass: "text-center py-3 text-muted",
            staticStyle: { "font-size": "0.9rem" },
          },
          [
            _vm._v(
              " Coming soon: Live DJ & Performer integrations, in-app messaging, and social games to keep the party going 🎶💬 "
            ),
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "row align-items-md-stretch" }, [
      _c("div", { class: _vm.isSignedIn ? "col-md-6" : "col-12" }, [
        !_vm.isSignedIn
          ? _c(
              "div",
              { staticClass: "try-vibetap-wrapper mb-4 rounded shadow-lg" },
              [_c("div", { staticClass: "qr-header-bar" }), _vm._m(1)]
            )
          : this.$store.state.venues.length === 0
          ? _c(
              "div",
              { staticClass: "h-100 p-5 text-bg-dark rounded-3 mb-2" },
              [
                _c("h2", [_vm._v("Setup and manage your business!!")]),
                _c("p", [
                  _vm._v(
                    "We offer a free service to help you setup your business but you are free to setup the data yourself. Please click the link to see the instructions for bar setup and usage, or schedule a meeting with us below."
                  ),
                ]),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btnAccent me-2",
                    attrs: { to: "/Instructions" },
                  },
                  [_vm._v("Instructions")]
                ),
              ],
              1
            )
          : _c("div", { staticClass: "metrics-container" }, [
              _c("div", { staticClass: "tab-selector" }, [
                _c(
                  "button",
                  {
                    class: { active: _vm.selectedTab === "daily" },
                    on: {
                      click: function ($event) {
                        _vm.selectedTab = "daily"
                      },
                    },
                  },
                  [_vm._v("Today")]
                ),
                _c(
                  "button",
                  {
                    class: { active: _vm.selectedTab === "monthly" },
                    on: {
                      click: function ($event) {
                        _vm.selectedTab = "monthly"
                      },
                    },
                  },
                  [_vm._v("This Month")]
                ),
              ]),
              _c("div", { staticClass: "last-updated" }, [
                _c("small", [
                  _vm._v("Last updated: " + _vm._s(_vm.lastUpdated)),
                ]),
              ]),
              _c("div", { staticClass: "metrics-card-2x2 h-100 pt-5" }, [
                _c("div", { staticClass: "metric" }, [
                  _c("h3", [_vm._v("Revenue")]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.selectedTab === "daily"
                            ? _vm.centsToDollars(_vm.metrics.totalRevenueByDay)
                            : _vm.centsToDollars(_vm.metrics.totalRevenueMonth)
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "metric" }, [
                  _c("h3", [_vm._v("Total Orders")]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.selectedTab === "daily"
                            ? _vm.metrics.totalOrdersToday
                            : _vm.metrics.totalOrdersMonth
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "metric" }, [
                  _c("h3", [_vm._v("Avg Wait Time")]),
                  _c("p", { staticClass: "value" }, [
                    _vm._v(" " + _vm._s(_vm.displayWaitTime) + " "),
                  ]),
                ]),
                _vm.stripeAccountCreated
                  ? _c("div", { staticClass: "metric" }, [
                      _c("h3", [_vm._v("Stripe Balance")]),
                      _c("p", { staticClass: "value" }, [
                        _vm._v("$ " + _vm._s(_vm.metrics.stripeTotal)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]),
      ]),
      _vm.isSignedIn
        ? _c("div", { staticClass: "col-md-6 top-margin-mobile" }, [
            _c("img", {
              staticClass: "image-visual mb-2 h-100 rounded-3",
              attrs: { src: require("../assets/Visual.jpg") },
            }),
          ])
        : _vm._e(),
    ]),
    _vm.isSignedIn && _vm.isBusiness
      ? _c(
          "div",
          { staticClass: "h-100 p-5 text-bg-dark rounded-3 mt-3" },
          [_c("EmployeeCode")],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "h-100 p-5 rounded-3 contact-us mt-4" }, [
      _c("h2", [_vm._v("Contact Us")]),
      _c("p", [
        _vm._v(
          "If you have any questions or need assistance, please feel free to contact us/schedule an appointment:"
        ),
      ]),
      _vm._m(2),
      _c("p", [_c("ScheduleDemo", { attrs: { signedIn: _vm.isSignedIn } })], 1),
      _c("p", [
        _vm._v(
          " We're available to schedule appointments to set up your business data and provide software training. Please contact us to arrange a suitable time. "
        ),
      ]),
      _c("p", [_vm._v("We're here to help!")]),
    ]),
    _c("footer", { staticClass: "pt-3 mt-4 text-muted border-top" }, [
      _vm._v(" © 2024 "),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "hero-title" }, [
      _vm._v(" Ditch the Line. Boost Bar Sales."),
      _c("br"),
      _vm._v("Let Guests Order from Their Phone! "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "try-vibetap-content row g-0 align-items-center p-4" },
      [
        _c(
          "div",
          {
            staticClass:
              "col-lg-12 d-flex flex-column flex-lg-row align-items-center",
          },
          [
            _c(
              "div",
              { staticClass: "text-white pe-lg-5 mb-4 mb-lg-0 col-lg-6" },
              [
                _c(
                  "h2",
                  {
                    staticClass: "fw-bold mb-3",
                    staticStyle: { "font-size": "28px" },
                  },
                  [_vm._v("Try VibeTap Right Now")]
                ),
                _c("p", [
                  _vm._v(
                    " See how your guests will experience VibeTap — right from their mobile device. Our platform is built for seamless ordering and pickup at bars, clubs, and events. "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " Scan the QR code below to open a fully interactive preview of the app. You’ll be able to: "
                  ),
                ]),
                _c("ul", [
                  _c("li", [_vm._v("Browse a sample menu")]),
                  _c("li", [_vm._v("Place a test order (pickup or table)")]),
                  _c("li", [_vm._v("Receive a sample pickup notification")]),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("No downloads required")]),
                  _vm._v(" — just scan and go."),
                ]),
                _c("p", { staticClass: "mt-3" }, [
                  _c("em", [
                    _vm._v(
                      "Download the full app to test the complete VibeTap experience!!"
                    ),
                  ]),
                ]),
              ]
            ),
            _c("div", { staticClass: "text-center col-lg-6" }, [
              _c("img", {
                staticClass: "qr-img img-fluid mb-2",
                staticStyle: { "max-width": "240px" },
                attrs: {
                  src: require("../assets/TestQRTable.jpg"),
                  alt: "Test VibeTap QR",
                },
              }),
              _c("p", { staticClass: "text-secondary small" }, [
                _vm._v("Scan with your phone camera or "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://order.vibe-tap.com?tableID=685ba02ba9cdbe0255b40636",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(" click here")]
                ),
                _vm._v(" to test the experience"),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Email:")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "mailto:info@example.com" } }, [
        _vm._v("help@vibe-tap.com"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }